// eslint-disable-next-line @typescript-eslint/no-unused-vars
import Icons, { IconsProps } from '../Icons';

// https://www.zhangxinxu.com/sp/svgo/

export default function (props: IconsProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.33668 12.8391L9.94442 18.9727L9.2641 19.7056L1.32812 12.3391L9.2641 4.97266L9.94442 5.70557L3.33668 11.8391H22.0631V12.8391H3.33668Z"
        fill="#323433"
      />
    </svg>
  );
}
